const KEY = 'meta_oauth_return';

/** Chamar antes de mandar o usuário ao Facebook: o MetaCallback devolve para cá. */
export function rememberOAuthReturn(path: string) {
    try {
        sessionStorage.setItem(KEY, path);
    } catch {
        /* sem storage o retorno cai no padrão */
    }
}

/**
 * Lido uma vez pelo MetaCallback. Só aceita rota da v2 — qualquer outra coisa
 * (ou nada) mantém o destino de sempre, /meta/connection.
 */
export function consumeOAuthReturn(fallback = '/meta/connection'): string {
    try {
        const v = sessionStorage.getItem(KEY);
        sessionStorage.removeItem(KEY);
        return v && v.startsWith('/v2/meta/') ? v : fallback;
    } catch {
        return fallback;
    }
}
